// Core
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { StateLoader, StateSaver } from './localStorage';

// Reducers
import { initializingReducer, sortingReducer } from './volunteers/slices';

const reducers = {
  ...initializingReducer,
  ...sortingReducer,
};

const preloadedState = StateLoader();

const middleware = [];

const store = configureStore({
  reducer: combineReducers(reducers),
  middleware: middleware,
  preloadedState: preloadedState,
});

store.subscribe(() => {
  StateSaver({ ...store.getState() });
});

export default store;
